const shrinkAddress = address => `${address?.slice(0, 9)}...${address?.slice(-4)}`
export default shrinkAddress
